import { useLocation, useNavigate } from "react-router-dom";
import { styles } from "../../stylesSettings";
import { Box } from "@mui/material";
import { useAppSelector } from "@/hooks/useAppSelector";

import SettingTitle from "../../component/SettingTitle";
import { useGetUserByUidQuery } from "@/store/api/userApi";
import { Navigate } from "react-router-dom";
import AccountInfoItem from "./AccountInformationItem";
import CustomToast from "@/components/UI/CustomToast/CustomToast";
import { useEffect, useState } from "react";

const AccountInformation = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [toast, setToast] = useState<{ message: string; success: boolean } | null>(null);
  const { user: authUser } = useAppSelector((state) => state.auth);
  if (!authUser) return <Navigate to="/" replace />;

  const { data: user } = useGetUserByUidQuery(authUser.uid, {
    skip: !authUser?.uid,
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });

  const accountItems = [
    {
      label: "Username",
      value: user?.username,
      onClick: () =>
        navigate("/settings/account/change-username", { state: { username: user?.username } }),
    },
    {
      label: "Email",
      value: user?.email,
      onClick: () => navigate("/settings/account/change-email"),
    },
  ];

  useEffect(() => {
    if (location.state?.message) {
      setToast({
        message: location.state.message,
        success: location.state.success ?? true,
      });

      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <>
      {toast && (
        <CustomToast
          message={toast.message}
          success={toast.success}
          onClose={() => setToast(null)}
        />
      )}
      <SettingTitle title="Account information" back isActive={true} />
      <Box
        sx={styles.accountInformationConteiner}
        flexDirection="column"
        className="hide-scrollbar"
      >
        {accountItems.map((item) => (
          <AccountInfoItem
            key={item.label}
            label={item.label}
            value={item.value}
            onClick={item.onClick}
          />
        ))}
      </Box>
    </>
  );
};

export default AccountInformation;
